import { TRecalculateItem } from '@data/types';
import { NONE_RECALCULATE_ID } from '../constants';
import { SegmentedVariable } from '../data/entities';

export function segmentedVariableMapper(values: SegmentedVariable[]) {
  const add = (item: SegmentedVariable) => _sort([...values, item]);

  const merge = (items: SegmentedVariable[]) => _sort([...values, ...items]);

  const removeById = (id: string) => values.filter((i) => i.id !== id);

  const _sort = (items: SegmentedVariable[]) => {
    const activeItems = items.filter((i) => i.isRecalculateEnable());
    const inactiveItems = items
      .filter((i) => !i.isRecalculateEnable())
      .map((i) => i.copyWith({ priority: null }));

    const sortActiveItems = activeItems
      .sort((a, b) => (a.priority < b.priority ? -1 : 1))
      .map((i, idx) => i.copyWith({ priority: idx + 1 }));

    const listItems = [sortActiveItems, inactiveItems].flat();

    return listItems;
  };

  const sortBy = () => _sort(values);

  const changeRecalculate = (id: string, recalculate: TRecalculateItem) => {
    const prev = values.find((i) => i.id === id);
    const rest = values.filter((i) => i.id !== id);
    const activeItems = values.filter((i) => i.isRecalculateEnable()).length;

    const newItem = prev.setRecalculate(recalculate);

    const list = [
      ...rest,
      prev.recalculate === NONE_RECALCULATE_ID
        ? newItem.setPriority(activeItems + 1)
        : newItem,
    ];

    return _sort(list);
  };

  return {
    add,
    merge,
    removeById,
    sortBy,
    changeRecalculate,
  };
}
